<template>
    <section class="quiz">
        <form class="swiper">
            <div class="swiper-wrapper">
                <div v-for="(step, index) in steps" class="swiper-slide">
                    <div class="lora mb-4 text-big font-weight-bold" v-text="step.title"></div>

                    <div v-if="step.items" class="filter__item quiz__item">
                        <label v-for="item in step.items" class="radio">
                            <input type="radio" :name="'step' + index" @change="setStepSelected(item.title)" :value="item.filter">
                            <span class="checkbox__label" v-text="item.title"></span>
                        </label>
                    </div>

                    <div v-else :class="['quiz__item', 'step-' + step.slot]" :ref="step.slot" :data-event="step.title">
                        <slot :name="step.slot"></slot>
                    </div>
                </div>
            </div>
        </form>

        <div class="text-center d-flex d-md-flex my-4 justify-content-center">
            <button class="btn w-50 mr-1" @click="prevStep" :disabled="swiper.activeIndex === 0">&larr; Назад</button>
            <button class="btn w-50 ml-1" @click="nextStep" :disabled="selected[swiper.activeIndex] === undefined && swiper.activeIndex !== 3">
                {{ isLastStep ? 'Подобрать' : 'Вперёд &rarr;' }}
            </button>
        </div>
    </section>
</template>

<script>
import { Swiper } from 'swiper'

export default {
    data() {
        return {
            p: 1,
            swiper: {},
            initParams: {
                p: 1,
                limit: 1,
                partner: 'gdebar',
                'sorting[rating]': 'desc'
            },
            filters: {},
            selected: [],
            steps: [
                {
                    title: 'Цель посещения',
                    items: [
                        {
                            title: 'Выпить в баре или пабе',
                            filter: 'mainType[]=3&mainType[]=43&mainType[]=21&mainType[]=48&mainType[]=52',
                        },
                        {
                            title: 'Пообщаться в тишине',
                            filter: 'mainType[]=21&mainType[]=2&mainType[]=1'
                        },
                        {
                            title: 'Спеть в караоке',
                            filter: 'mainType[]=7&mainType[]=50'
                        },
                        {
                            title: 'Потанцевать под DJ-сеты',
                            filter: 'options[dancefloor]=on&options[dj]=on'
                        },
                        {
                            title: 'Насладиться живой музыкой',
                            filter: 'options[live_music]=on'
                        },
                        {
                            title: 'Пойти с детьми (детская комната)',
                            filter: 'mainType[]=2&mainType[]=1&options[kid][]=1&options[kid][]=9&type[]=2&type[]=1'
                        },
                        {
                            title: 'Исследовать новые заведения',
                            filter: 'newest=1'
                        },
                        {
                            title: 'Провести банкет со своим алкоголем',
                            filter: 'banket[with_self][0]=4'
                        },
                        {
                            title: 'Отметить день рождения со скидкой 20% и более',
                            filter: 'special[17][kitchen]=20'
                        },
                        {
                            title: 'Я не нашёл подходящий вариант',
                            filter: ''
                        }
                    ]
                },
                {
                    title: 'Бюджет/чел.',
                    slot: 'budzhet'
                },
                {
                    title: 'Где',
                    slot: 'gde'
                },
                {
                    title: 'Когда',
                    slot: 'kogda'
                }
            ]
        }
    },

    computed: {
        isLastStep() {
            return this.swiper.activeIndex === this.steps.length - 1
        }
    },

    methods: {
        runEvent(name) {
            $app.runEvent('click', { 'пошаговый подбор': name })
        },

        setStepSelected(name) {
            this.runEvent(name)

            this.$set(this.selected, this.swiper.activeIndex, true)
        },

        nextStep() {
            if (this.isLastStep) {
                this.runEvent('подобрать')

                this.filters = new URLSearchParams(this.initParams)

                for (let [name, val] of new FormData(this.$el.firstElementChild).entries()) {
                    if (val) {
                        if (name.startsWith('step')) {
                            for (let [stepName, stepVal] of new URLSearchParams(val).entries()) {
                                this.filters.append(stepName, stepVal)
                            }
                        } else {
                            this.filters.append(name, val)
                        }
                    }
                }

                this.p = 1

                $filter.processRequest(this.filters.toString(), false, $app.urlPrefix + '/bar/stepbystep/find').then(this.bindLikeDislike)
            } else {
                this.swiper.slideNext()

                this.runEvent('вперёд')
            }
        },

        prevStep() {
            this.swiper.slidePrev()

            this.runEvent('назад')
        },

        bindLikeDislike() {
            document.querySelectorAll('#paginator-next-url button').forEach(btn => {
                btn.addEventListener('click', () => {
                    if (btn.classList.contains('btn--map')) {
                        return $filter.mapHelper.loadMap({ 'пошаговый подбор': 'карта' }, this.filters.toString())
                    }

                    let isLike = btn.classList.contains('btn--green')

                    this.runEvent(isLike ? 'лайк' : 'дизлайк')

                    if (isLike) {
                        $.get($app.urlPrefix + '/bar/stepbystep/like', () => {
                            $listing.$el.querySelector('.place__favorite:not(.gbi-heart-filled)')?.click()
                        })
                    }

                    this.filters.set('p', ++this.p)

                    $filter.processRequest(this.filters.toString(), false, $app.urlPrefix + '/bar/stepbystep/find').then(this.bindLikeDislike)
                })
            })
        }
    },

    mounted() {
        $.get($app.urlPrefix + '/page/holiday/stepbystep', json => {
            json.holidays.forEach(holiday => {
                this.steps[0].items.unshift({
                    title: holiday.povod,
                    filter: holiday.filter
                })
            })

            $filter.helpers.processLimited(this.$el)

            Object.keys(this.$refs).forEach(slot => {
                this.$refs[slot][0].querySelectorAll('select,input').forEach(input => {
                    input.addEventListener('change', () => {
                        let event = input.closest('.quiz__item').dataset.event + ' '

                        if (input.type === 'radio') {
                            event = input.nextElementSibling.textContent.trim()
                        } else if (input.type === 'checkbox') {
                            event = input.checked ? input.nextElementSibling.nextElementSibling.textContent.trim() : ''
                        } else if (input.type === 'select-one') {
                            if (input.previousElementSibling?.classList.contains('text-medium')) {
                                event += input.previousElementSibling.textContent.trim()
                            }
                        }

                        if (input.name === 'schedule[day]' && input.value === '0') {
                            input.parentNode.nextElementSibling.children[1].value = ''
                        }

                        if (event) {
                            this.setStepSelected(event + ' ' + input.value)
                        }
                    })
                })

                this.$refs[slot][0].querySelectorAll('a.checkbox__label').forEach(a => {
                    a.addEventListener('click', () => {
                        a.previousElementSibling.dispatchEvent(new Event('change'))
                    })
                })
            })

            this.swiper = new Swiper(this.$el.firstElementChild, {
                autoHeight: true,
                allowTouchMove: false
            })
        })
    }
}
</script>

<style lang="scss">
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins/breakpoints';

.quiz {
    @include media-breakpoint-up(md) {
        .btn {
            width: auto !important;
        }
    }

    &__item {
        margin: 0 auto;
        text-align: left;
        max-width: max-content;
    }

    .radio {
        display: flex;
        margin: .25rem 0;
    }

    .step-budzhet {
        .filter__item {
            margin-bottom: .5rem;
        }
    }

    .input__field--search {
        margin: 1rem 0;
    }

    .swiper-slide {
        flex-direction: column;
    }
}
</style>